import { useQuery } from "react-query";
import { api, ApiError } from "utils/api";
import type { ProjectReview } from "../types";

const getUserReviews = (userId: string) => api(`/users/${userId}/reviews`);

const useUserReviews = (userId: string) =>
  useQuery<ProjectReview[], ApiError>(
    ["user", userId, "reviews"],
    () => getUserReviews(userId),
    {
      enabled: !!userId,
    }
  );

export { useUserReviews };
